import { loadModuleDirectly } from '../../../../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { RouterStore } from '../../../../../../@Service/Router/RouterStore';


export default function openTranslationCenter()
{
    const routerStore = loadModuleDirectly(RouterStore);
    routerStore.route(`/translation-center`);
}
